export const GET_COLORS_REQUEST = "GET_COLORS_REQUEST";
export const GET_COLORS_SUCCESS = "GET_COLORS_SUCCESS";
export const GET_COLORS_FAILURE = "GET_COLORS_FAILURE";
